import {FC, useMemo} from 'react';
import {DailyActivity, DailyActivityData} from './DailyActivity';
import {
  DateToDateSituation,
  OrdersData,
  OutputData,
} from './DateToDateSituation';
import {Tabs} from 'antd';

export const LOCATIONS = {
  NIMES: 'Nîmes',
  LYON: 'Lyon',
};

export const NIMES_PIECE_TYPES = {
  PROTHESE: 'Prothèse/IP',
  ANTIBRUIT: 'Anti-bruit',
  ELECTRO: 'Electro/Musique',
};

export const LYON_PIECE_TYPES = {
  TRADITIONAL: 'Traditionnel',
  THREED: '3D',
};

export const LOCATIONS_COLORS = {
  [LOCATIONS.NIMES]: '#4096ff',
  [LOCATIONS.LYON]: '#73d13d',
};

export const PALETTE = {
  [LOCATIONS.NIMES]: {
    [NIMES_PIECE_TYPES.PROTHESE]: '#4096ff',
    [NIMES_PIECE_TYPES.ANTIBRUIT]: '#69b1ff',
    [NIMES_PIECE_TYPES.ELECTRO]: '#91caff',
  },
  [LOCATIONS.LYON]: {
    [LYON_PIECE_TYPES.TRADITIONAL]: '#73d13d',
    [LYON_PIECE_TYPES.THREED]: '#95de64',
  },
};

export const Stats: FC = () => {
  const dailyActivity: DailyActivityData[] = [
    {
      family: 'AUDIO',
      indicator: 'Embouts de prothèse commandés',
      location: 'Nîmes',
      number: 762,
      amount: 22027.61,
      date: '2024-02-10',
    },
    {
      family: 'AUDIO',
      indicator: 'Embouts de prothèse commandés',
      location: 'Lyon',
      number: 1502,
      amount: 42951.8,
      date: '2024-02-10',
    },
    {
      family: 'AUDIO',
      indicator: 'Embouts de prothèse produits',
      location: 'Nîmes',
      number: 1591,
      amount: 76186.94,
      date: '2024-02-10',
    },
    {
      family: 'AUDIO',
      indicator: 'Embouts de prothèse produits',
      location: 'Lyon',
      number: 821,
      amount: 48106.88,
      date: '2024-02-10',
    },
    {
      family: 'AUDIO',
      indicator: 'Anti-bruit/Anti-eau commandés',
      location: 'Nîmes',
      number: 2056,
      amount: 84421.98,
      date: '2024-02-10',
    },
    {
      family: 'AUDIO',
      indicator: 'Anti-bruit/Anti-eau commandés',
      location: 'Lyon',
      number: 557,
      amount: 14047.49,
      date: '2024-02-10',
    },
    {
      family: 'AUDIO',
      indicator: 'Anti-bruit/Anti-eau produits',
      location: 'Nîmes',
      number: 3549,
      amount: 181198.12,
      date: '2024-02-10',
    },
    {
      family: 'AUDIO',
      indicator: 'Anti-bruit/Anti-eau produits',
      location: 'Lyon',
      number: 348,
      amount: 15716.65,
      date: '2024-02-10',
    },
    {
      family: 'OTHER',
      indicator: 'Produits en musique',
      location: 'Nîmes',
      number: null,
      amount: 24355.04,
      date: '2024-02-10',
    },
    {
      family: 'OTHER',
      indicator: 'Produits en musique',
      location: 'Lyon',
      number: null,
      amount: null,
      date: '2024-02-10',
    },
    {
      family: 'AUDIO',
      indicator: 'Négoce vendu',
      location: 'Nîmes',
      number: null,
      amount: 83424.66,
      date: '2024-02-10',
    },
    {
      family: 'AUDIO',
      indicator: 'Négoce vendu',
      location: 'Lyon',
      number: null,
      amount: null,
      date: '2024-02-10',
    },
    {
      family: 'INDU',
      indicator: 'Nombre de rendez-vous clients réalisés et potentiel associé',
      location: null,
      number: null,
      amount: null,
      date: '2024-02-10',
    },
    {
      family: 'INDU',
      indicator: 'Nombre de devis réalisés et potentiel associé',
      location: null,
      number: null,
      amount: null,
      date: '2024-02-10',
    },
    {
      family: 'INDU',
      indicator: 'Anti-bruit commandés (paires)',
      location: null,
      number: 2528,
      amount: 221976.65,
      date: '2024-02-10',
    },
    {
      family: 'INDU',
      indicator: 'Anti-bruit produits (paires)',
      location: null,
      number: 3,
      amount: 211502.88,
      date: '2024-02-10',
    },
    {
      family: 'INDU',
      indicator: 'Négoce vendu',
      location: null,
      number: null,
      amount: 25585.94,
      date: '2024-02-10',
    },

    {
      family: 'AUDIO',
      indicator: 'Embouts de prothèse commandés',
      location: 'Nîmes',
      number: 1243,
      amount: 43567.61,
      date: '2024-05-13',
    },
    {
      family: 'AUDIO',
      indicator: 'Embouts de prothèse commandés',
      location: 'Lyon',
      number: 904,
      amount: 31092.8,
      date: '2024-05-13',
    },
    {
      family: 'AUDIO',
      indicator: 'Embouts de prothèse produits',
      location: 'Nîmes',
      number: 1373,
      amount: 62435.94,
      date: '2024-05-13',
    },
    {
      family: 'AUDIO',
      indicator: 'Embouts de prothèse produits',
      location: 'Lyon',
      number: 1110,
      amount: 59865.88,
      date: '2024-05-13',
    },
    {
      family: 'AUDIO',
      indicator: 'Anti-bruit/Anti-eau commandés',
      location: 'Nîmes',
      number: 2247,
      amount: 85639.98,
      date: '2024-05-13',
    },
    {
      family: 'AUDIO',
      indicator: 'Anti-bruit/Anti-eau commandés',
      location: 'Lyon',
      number: 451,
      amount: 11536.49,
      date: '2024-05-13',
    },
    {
      family: 'AUDIO',
      indicator: 'Anti-bruit/Anti-eau produits',
      location: 'Nîmes',
      number: 2984,
      amount: 163986.12,
      date: '2024-05-13',
    },
    {
      family: 'AUDIO',
      indicator: 'Anti-bruit/Anti-eau produits',
      location: 'Lyon',
      number: 560,
      amount: 21095.65,
      date: '2024-05-13',
    },
    {
      family: 'OTHER',
      indicator: 'Produits en musique',
      location: 'Nîmes',
      number: null,
      amount: 15942.04,
      date: '2024-05-13',
    },
    {
      family: 'OTHER',
      indicator: 'Produits en musique',
      location: 'Lyon',
      number: null,
      amount: 4563,
      date: '2024-05-13',
    },
    {
      family: 'AUDIO',
      indicator: 'Négoce vendu',
      location: 'Nîmes',
      number: null,
      amount: 95467.66,
      date: '2024-05-13',
    },
    {
      family: 'AUDIO',
      indicator: 'Négoce vendu',
      location: 'Lyon',
      number: null,
      amount: null,
      date: '2024-05-13',
    },
    {
      family: 'INDU',
      indicator: 'Nombre de rendez-vous clients réalisés et potentiel associé',
      location: null,
      number: null,
      amount: null,
      date: '2024-05-13',
    },
    {
      family: 'INDU',
      indicator: 'Nombre de devis réalisés et potentiel associé',
      location: null,
      number: null,
      amount: null,
      date: '2024-05-13',
    },
    {
      family: 'INDU',
      indicator: 'Anti-bruit commandés (paires)',
      location: null,
      number: 3104,
      amount: 256493.65,
      date: '2024-05-13',
    },
    {
      family: 'INDU',
      indicator: 'Anti-bruit produits (paires)',
      location: null,
      number: 3,
      amount: 211502.88,
      date: '2024-05-13',
    },
    {
      family: 'INDU',
      indicator: 'Négoce vendu',
      location: null,
      number: null,
      amount: 25585.94,
      date: '2024-05-13',
    },

    {
      family: 'AUDIO',
      indicator: 'Embouts de prothèse commandés',
      location: 'Nîmes',
      number: 453,
      amount: 13456.61,
      date: '2024-08-23',
    },
    {
      family: 'AUDIO',
      indicator: 'Embouts de prothèse commandés',
      location: 'Lyon',
      number: 332,
      amount: 11532.8,
      date: '2024-08-23',
    },
    {
      family: 'AUDIO',
      indicator: 'Embouts de prothèse produits',
      location: 'Nîmes',
      number: 864,
      amount: 46472.94,
      date: '2024-08-23',
    },
    {
      family: 'AUDIO',
      indicator: 'Embouts de prothèse produits',
      location: 'Lyon',
      number: 459,
      amount: 29412.88,
      date: '2024-08-23',
    },
    {
      family: 'AUDIO',
      indicator: 'Anti-bruit/Anti-eau commandés',
      location: 'Nîmes',
      number: 1159,
      amount: 43951.98,
      date: '2024-08-23',
    },
    {
      family: 'AUDIO',
      indicator: 'Anti-bruit/Anti-eau commandés',
      location: 'Lyon',
      number: 432,
      amount: 11945.49,
      date: '2024-08-23',
    },
    {
      family: 'AUDIO',
      indicator: 'Anti-bruit/Anti-eau produits',
      location: 'Nîmes',
      number: 2294,
      amount: 125432.12,
      date: '2024-08-23',
    },
    {
      family: 'AUDIO',
      indicator: 'Anti-bruit/Anti-eau produits',
      location: 'Lyon',
      number: 180,
      amount: 8947.65,
      date: '2024-08-23',
    },
    {
      family: 'OTHER',
      indicator: 'Produits en musique',
      location: 'Nîmes',
      number: null,
      amount: 13594.04,
      date: '2024-08-23',
    },
    {
      family: 'OTHER',
      indicator: 'Produits en musique',
      location: 'Lyon',
      number: null,
      amount: null,
      date: '2024-08-23',
    },
    {
      family: 'AUDIO',
      indicator: 'Négoce vendu',
      location: 'Nîmes',
      number: null,
      amount: 58968.66,
      date: '2024-08-23',
    },
    {
      family: 'AUDIO',
      indicator: 'Négoce vendu',
      location: 'Lyon',
      number: null,
      amount: null,
      date: '2024-08-23',
    },
    {
      family: 'INDU',
      indicator: 'Nombre de rendez-vous clients réalisés et potentiel associé',
      location: null,
      number: null,
      amount: null,
      date: '2024-08-23',
    },
    {
      family: 'INDU',
      indicator: 'Nombre de devis réalisés et potentiel associé',
      location: null,
      number: null,
      amount: null,
      date: '2024-08-23',
    },
    {
      family: 'INDU',
      indicator: 'Anti-bruit commandés (paires)',
      location: null,
      number: 1394,
      amount: 145293.65,
      date: '2024-08-23',
    },
    {
      family: 'INDU',
      indicator: 'Anti-bruit produits (paires)',
      location: null,
      number: 300,
      amount: 119483.88,
      date: '2024-08-23',
    },
    {
      family: 'INDU',
      indicator: 'Négoce vendu',
      location: null,
      number: null,
      amount: 16384.94,
      date: '2024-08-23',
    },

    {
      family: 'AUDIO',
      indicator: 'Embouts de prothèse commandés',
      location: 'Nîmes',
      number: 1230,
      amount: 40528.61,
      date: '2024-11-28',
    },
    {
      family: 'AUDIO',
      indicator: 'Embouts de prothèse commandés',
      location: 'Lyon',
      number: 947,
      amount: 30248.8,
      date: '2024-11-28',
    },
    {
      family: 'AUDIO',
      indicator: 'Embouts de prothèse produits',
      location: 'Nîmes',
      number: 2041,
      amount: 98472.94,
      date: '2024-11-28',
    },
    {
      family: 'AUDIO',
      indicator: 'Embouts de prothèse produits',
      location: 'Lyon',
      number: 1057,
      amount: 58473.88,
      date: '2024-11-28',
    },
    {
      family: 'AUDIO',
      indicator: 'Anti-bruit/Anti-eau commandés',
      location: 'Nîmes',
      number: 2583,
      amount: 102048.98,
      date: '2024-11-28',
    },
    {
      family: 'AUDIO',
      indicator: 'Anti-bruit/Anti-eau commandés',
      location: 'Lyon',
      number: 763,
      amount: 19573.49,
      date: '2024-11-28',
    },
    {
      family: 'AUDIO',
      indicator: 'Anti-bruit/Anti-eau produits',
      location: 'Nîmes',
      number: 4295,
      amount: 212492.12,
      date: '2024-11-28',
    },
    {
      family: 'AUDIO',
      indicator: 'Anti-bruit/Anti-eau produits',
      location: 'Lyon',
      number: 487,
      amount: 19843.65,
      date: '2024-11-28',
    },
    {
      family: 'OTHER',
      indicator: 'Produits en musique',
      location: 'Nîmes',
      number: null,
      amount: 32094.04,
      date: '2024-11-28',
    },
    {
      family: 'OTHER',
      indicator: 'Produits en musique',
      location: 'Lyon',
      number: null,
      amount: null,
      date: '2024-11-28',
    },
    {
      family: 'AUDIO',
      indicator: 'Négoce vendu',
      location: 'Nîmes',
      number: null,
      amount: 98247.66,
      date: '2024-11-28',
    },
    {
      family: 'AUDIO',
      indicator: 'Négoce vendu',
      location: 'Lyon',
      number: null,
      amount: null,
      date: '2024-11-28',
    },
    {
      family: 'INDU',
      indicator: 'Nombre de rendez-vous clients réalisés et potentiel associé',
      location: null,
      number: null,
      amount: null,
      date: '2024-11-28',
    },
    {
      family: 'INDU',
      indicator: 'Nombre de devis réalisés et potentiel associé',
      location: null,
      number: null,
      amount: null,
      date: '2024-11-28',
    },
    {
      family: 'INDU',
      indicator: 'Anti-bruit commandés (paires)',
      location: null,
      number: 3014,
      amount: 298741.65,
      date: '2024-11-28',
    },
    {
      family: 'INDU',
      indicator: 'Anti-bruit produits (paires)',
      location: null,
      number: 20,
      amount: 220423.88,
      date: '2024-11-28',
    },
    {
      family: 'INDU',
      indicator: 'Négoce vendu',
      location: null,
      number: null,
      amount: 34028.94,
      date: '2024-11-28',
    },
  ];

  const initialOrders: OrdersData[] = useMemo(
    () => [
      {
        location: 'Nîmes',
        total: 506,
        industry: 151,
        audio: 355,
        audioWeb: 174,
        date: '2024-02-10',
      },
      {
        location: 'Lyon',
        total: 85,
        industry: null,
        audio: 85,
        audioWeb: 43,
        date: '2024-02-10',
      },
      {
        location: 'Nîmes',
        total: 394,
        industry: 133,
        audio: 261,
        audioWeb: 142,
        date: '2024-05-13',
      },
      {
        location: 'Lyon',
        total: 100,
        industry: null,
        audio: 100,
        audioWeb: 56,
        date: '2024-05-13',
      },
      {
        location: 'Nîmes',
        total: 287,
        industry: 74,
        audio: 213,
        audioWeb: 135,
        date: '2024-08-23',
      },
      {
        location: 'Lyon',
        total: 67,
        industry: null,
        audio: 67,
        audioWeb: 39,
        date: '2024-08-23',
      },
      {
        location: 'Nîmes',
        total: 683,
        industry: 221,
        audio: 462,
        audioWeb: 240,
        date: '2024-11-28',
      },
      {
        location: 'Lyon',
        total: 123,
        industry: null,
        audio: 123,
        audioWeb: 71,
        date: '2024-11-28',
      },
    ],
    [],
  );

  const initialOutputs: OutputData[] = useMemo(
    () => [
      {
        location: 'Nîmes',
        pieceType: 'Prothèse/IP',
        number: 259,
        date: '2024-02-10',
      },
      {
        location: 'Nîmes',
        pieceType: 'Anti-bruit',
        number: 571,
        date: '2024-02-10',
      },
      {
        location: 'Nîmes',
        pieceType: 'Electro/Musique',
        number: 6,
        date: '2024-02-10',
      },
      {
        location: 'Lyon',
        pieceType: 'Traditionnel',
        number: 107,
        date: '2024-02-10',
      },
      {location: 'Lyon', pieceType: '3D', number: null, date: '2024-02-10'},
      {
        location: 'Nîmes',
        pieceType: 'Prothèse/IP',
        number: 218,
        date: '2024-05-13',
      },
      {
        location: 'Nîmes',
        pieceType: 'Anti-bruit',
        number: 485,
        date: '2024-05-13',
      },
      {
        location: 'Nîmes',
        pieceType: 'Electro/Musique',
        number: 5,
        date: '2024-05-13',
      },
      {
        location: 'Lyon',
        pieceType: 'Traditionnel',
        number: 94,
        date: '2024-05-13',
      },
      {location: 'Lyon', pieceType: '3D', number: 3, date: '2024-05-13'},
      {
        location: 'Nîmes',
        pieceType: 'Prothèse/IP',
        number: 183,
        date: '2024-08-23',
      },
      {
        location: 'Nîmes',
        pieceType: 'Anti-bruit',
        number: 392,
        date: '2024-08-23',
      },
      {
        location: 'Nîmes',
        pieceType: 'Electro/Musique',
        number: 2,
        date: '2024-08-23',
      },
      {
        location: 'Lyon',
        pieceType: 'Traditionnel',
        number: 67,
        date: '2024-08-23',
      },
      {location: 'Lyon', pieceType: '3D', number: null, date: '2024-08-23'},
      {
        location: 'Nîmes',
        pieceType: 'Prothèse/IP',
        number: 312,
        date: '2024-11-28',
      },
      {
        location: 'Nîmes',
        pieceType: 'Anti-bruit',
        number: 683,
        date: '2024-11-28',
      },
      {
        location: 'Nîmes',
        pieceType: 'Electro/Musique',
        number: 11,
        date: '2024-11-28',
      },
      {
        location: 'Lyon',
        pieceType: 'Traditionnel',
        number: 135,
        date: '2024-11-28',
      },
      {location: 'Lyon', pieceType: '3D', number: 10, date: '2024-11-28'},
    ],
    [],
  );

  return (
    <Tabs>
      <Tabs.TabPane tab="Indicateurs d'activité journaliers" key="item-1">
        <DailyActivity initialData={dailyActivity} />
      </Tabs.TabPane>
      <Tabs.TabPane tab="Situation date à date" key="item-2">
        <DateToDateSituation
          initialOrders={initialOrders}
          initialOuputs={initialOutputs}
        />
      </Tabs.TabPane>
    </Tabs>
  );
};
